import styled from 'styled-components'

import { Box, Modal } from 'app/components/design-system-components'
import { Text } from 'app/components/design-system-components/typography'
import theme from 'app/match/applicationReportPDF/assets/theme'

const StyledUL = styled.ul`
  padding-left: ${theme.space[13]}px !important;
  li {
    display: list-item;
    margin-bottom: ${theme.space[3]}px;
    line-height: 1.6;
  }
`

interface MissingApplicantEmailLimitationsModalProps {
  toggleMissingEmailLimitationsModal: () => void
  submitMissingEmailLimitationsModal: () => void
}

export const MissingApplicantEmailLimitationsModal = ({
  toggleMissingEmailLimitationsModal,
  submitMissingEmailLimitationsModal,
}: MissingApplicantEmailLimitationsModalProps) => {
  const limitations = [
    `Application status notifications won't be sent the applicants (e.g. shortlisted, offered, etc).`,
    'Utility connection referrals cannot be sent automatically.',
    `Successful applications cannot be synchronised with the PMS.`,
  ]

  const modalBody = (
    <Box p={4}>
      <Box mb={4}>
        <Text
          m={0}
          fontSize={theme.fontSizes.pLarge16}
          fontWeight={theme.fontWeights.bold}
        >
          Applications without a primary applicant email address will have
          limited functionality:
        </Text>
      </Box>

      <Box mb={4} className="fs16">
        <StyledUL>
          {limitations.map((limitation, index) => (
            <li key={index}>{limitation}</li>
          ))}
        </StyledUL>
      </Box>

      <Box>
        <Text>
          Ensure you save the primary applicant's email address to enable this
          functionality.
        </Text>
      </Box>
    </Box>
  )

  return (
    <Modal
      toggleModal={() => toggleMissingEmailLimitationsModal()}
      modalHeading={'Application Limitations'}
      modalBody={modalBody}
      primaryLabel={'Continue'}
      primaryAction={() => submitMissingEmailLimitationsModal()}
      secondaryLabel={'Cancel'}
      secondaryAction={() => toggleMissingEmailLimitationsModal()}
      primaryButtonLoading={false}
      modalFooter={undefined}
    />
  )
}

export default MissingApplicantEmailLimitationsModal
